import React from "react";
import { motion } from "framer-motion";
import { Mail, MessageCircle, ArrowUpRight } from "lucide-react";
import { Reveal, RevealWords, Magnetic } from "../../lib/ui-motion";
import { NeuralBackground } from "./NeuralBackground";
import { useLang, CONTACT } from "../../i18n";

export const Contact = () => {
  const { t } = useLang();
  const c = t.contact;
  const mailto = `mailto:${CONTACT.email}?subject=${encodeURIComponent("Discovery Call — ruiguimaraes.dev")}`;
  const whatsapp = `${CONTACT.whatsapp}?text=${encodeURIComponent(c.waMsg)}`;

  return (
    <section id="contact" className="relative py-28 md:py-40 overflow-hidden" data-testid="contact-section">
      <div className="absolute inset-0 z-0 opacity-40 radial-fade">
        <NeuralBackground density={0.00006} />
      </div>
      <div className="absolute left-1/2 bottom-0 -translate-x-1/2 h-[400px] w-[700px] rounded-full bg-flame/15 blur-[160px] pointer-events-none" />

      <div className="relative z-10 mx-auto max-w-[1100px] px-6 md:px-12 text-center">
        <Reveal>
          <div className="flex items-center justify-center gap-3 mb-8">
            <span className="h-px w-8 bg-flame" />
            <span className="text-xs sm:text-sm font-mono uppercase tracking-[0.25em] text-flame">{c.overline}</span>
            <span className="h-px w-8 bg-flame" />
          </div>
        </Reveal>

        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold leading-[1.05] text-balance">
          <RevealWords text={c.line1} />
        </h2>
        <Reveal delay={0.2}>
          <p className="mt-8 mx-auto max-w-2xl text-xl md:text-2xl text-white/70 font-heading font-medium text-balance">
            {c.line2}
          </p>
        </Reveal>

        <Reveal delay={0.35}>
          <div className="mt-12 flex flex-col items-center gap-5">
            <Magnetic strength={0.4}>
              <a
                href={whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                data-cursor="hover"
                data-testid="contact-cta"
                className="group inline-flex items-center gap-3 rounded-full bg-flame px-9 py-4 text-lg font-semibold text-black hover:bg-flame-soft transition-colors glow-flame"
              >
                <MessageCircle size={20} />
                {c.cta}
                <ArrowUpRight size={20} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </Magnetic>
            <a href={mailto} data-cursor="hover" data-testid="contact-email"
              className="inline-flex items-center gap-2 text-white/50 hover:text-flame transition-colors">
              <Mail size={16} /> {c.email} — {CONTACT.email}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
